import {
    Avatar,
    Menu,
    MenuItemProps,
    useBreakpoints,
    useCdnAssets,
    useFileUrl,
    useRuntimeEnv,
    useRuntimeEnvRolesIncludes,
    useTranslation,
    useTranslationRoute,
    useUrlActive,
    useUserProfilePicture,
} from "@bsm/component";
import { useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import pkg from "../../../package.json";
import { useLeftSideBarMenu } from "./hooks/useLeftSideBarMenu";
import _ from "lodash";
import './css/navbar.css'

export const AdminLeftSideBar = (props: AdminLeftSideBarProps) => {

    const profilePictureUrl = useUserProfilePicture()
    const { runtimeEnv } = useRuntimeEnv();
    const roleIncludes = useRuntimeEnvRolesIncludes()
    const url = useTranslationRoute();
    const t = useTranslation();
    const menuItems = useLeftSideBarMenu();
    const { md } = useBreakpoints();
    const isActive = useUrlActive();

    const transformedMenuItems = useMemo(() => {
        return menuItems.map((menu) => {
            return {
                ...menu,
                items: menu.items?.filter((item) => _.isEmpty(item?.roles) || !!item?.roles?.every((role: string) => roleIncludes(role)))
            }
        }).filter((item) => !_.isEmpty(item.items))
    }, []);


    return (
        <aside className={`sidebar-left flex-col hidden md:flex ${props.open ? "open" : ""} !rounded-tr-3xl`}>
            <div
                className={`flex items-center h-[68px] sticky py-2 ${props.open ? "px-4" : "px-5 justify-center"}`}
            >
                <Link to="/">
                    <img
                        src={props.open ? `/assets/img/logo.png` : `/assets/img/favicon.png`}
                        alt="Logo"
                        className={props.open ? "h-16" : ""}
                    />
                </Link>
            </div>
            <div className="bg-[#8B0000] overflow-y-auto flex-1 space-y-4">
                <div
                    className={`
                        flex items-center text-xs gap-2 text-white
                        opacity-1 transition-all duration-150 !mt-[15px]
                        ${!props.open ? "hidden" : "px-5"} 
                    `}
                >
                    <Link to={url(`user/${runtimeEnv.user?.id}`)}>
                        <Avatar
                            src={profilePictureUrl(runtimeEnv?.user?.id!)}
                            fullName={runtimeEnv?.user?.fullName}
                        />
                    </Link>
                    <div className="flex flex-col gap-2 justify-center">
                        <Link to={url(`user/${runtimeEnv.user?.id}`)}>
                            <h6 className="font-bold text-white">
                                {runtimeEnv.user.fullName}
                            </h6>
                        </Link>
                        <Link to={url(`organisation/${runtimeEnv.organisation?.id}`)}>
                            <span className="text-center w-full">
                                {runtimeEnv.organisation?.designation}
                            </span>
                        </Link>
                    </div>
                </div>
                <div className={`${props.open ? "px-3" : ""}`}>
                    <Menu
                        items={transformedMenuItems}
                        onlyStartIcon={!md && !props.open}
                        className="text-white"
                        activeFn={(menu) => !!menu.link && isActive(menu.link)}
                    />
                </div>
                <div className="mt-4 px-4 text-[12px] text-white text-center">
                    <a className={!props.open ? "hidden" : ""} href="/">
                        {t(`Generic.de.${process.env.REACT_APP_NAME}`)}-
                        {pkg.version}
                    </a>{" "}
                    © {new Date().getFullYear()}
                </div>
            </div>
        </aside>
    );
};

type AdminLeftSideBarProps = {
    open: boolean;
};